import loadable from '@wix/yoshi-flow-editor/loadable';

export const MembersPage = loadable(
  () => import(/* webpackChunkName: "MembersPage" */ './MembersPage'),
  {
    resolveComponent: (component) => component.MembersPage,
  },
);
